export const pluralize = (
  config: {
    singular: string
    plural: string
  },
  count: number,
) => {
  return count > 1 ? config.plural : config.singular
}
